import { computed } from 'vue'
import { useUserStore } from '@/features/user/stores/user.store'

export function useUserProfile() {
  const store = useUserStore()

  return {
    profile: computed(() => store.profile),
    credits: computed(() => store.credits),
    subscription: computed(() => store.subscription),
    loading: computed(() => store.loading),
    error: computed(() => store.error),
    creditsError: computed(() => store.creditsError),
    userEmail: computed(() => store.userEmail),
    isAdmin: computed(() => store.isAdmin),
    isSalesUser: computed(() => store.isSalesUser),
    hasInfiniteSearches: computed(() => store.hasInfiniteSearches),
    isOrganicFreeUser: computed(() => store.isOrganicFreeUser),
    isImpersonated: computed(() => store.isImpersonated),
    fetchAll: store.fetchAll,
    fetchCredits: store.fetchCredits,
  }
}
